'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function median(arr, defaultValueIfEmpty) {
    if (arr.length === 0) {
        if (typeof defaultValueIfEmpty === 'number') {
            return defaultValueIfEmpty;
        }
        return null;
    }
    const sorted = [...arr].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    // If the length of the array is odd, return the middle element
    if (sorted.length % 2 === 1) {
        return sorted[mid];
    }
    // If the length of the array is even, return the average of the middle two elements
    return (sorted[mid - 1] + sorted[mid]) / 2;
}

exports.median = median;
//# sourceMappingURL=median.js.map
